/* OFX collection — functional dual-knob price slider (ITEM 6).
   Progressive enhancement over the inputs + "Apply price" fallback. Drag a knob
   (pointer) or use arrow keys to move it; the matching min/max text input updates
   live. Releasing a knob — or pressing Enter / blurring an input — submits the
   enclosing GET filter form, which preserves every other facet/sort param the
   same way the existing Apply button does. With JS off, the inputs + Apply button
   remain the working path (this file simply never runs).

   Units: data-min / data-max are in MAJOR units (dollars), matching the gte/lte
   URL param and the text inputs. (Shopify exposes range bounds in cents; the
   section template converts them before emitting these attributes.) */
(function () {
  function initSlider(root) {
    if (root.__ofxPriceInit) return;
    root.__ofxPriceInit = true;

    var min = parseFloat(root.getAttribute('data-min'));
    var max = parseFloat(root.getAttribute('data-max'));
    if (!isFinite(min) || !isFinite(max) || max <= min) return;

    var track = root.querySelector('[data-ofx-price-track]');
    var fill = root.querySelector('[data-ofx-price-fill]');
    var knobLo = root.querySelector('[data-ofx-price-knob="lo"]');
    var knobHi = root.querySelector('[data-ofx-price-knob="hi"]');
    var inputMin = root.querySelector('[data-ofx-price-min]');
    var inputMax = root.querySelector('[data-ofx-price-max]');
    if (!track || !fill || !knobLo || !knobHi || !inputMin || !inputMax) return;

    var form = root.closest('form');
    if (!form) return;

    // JS is live → hide the redundant Apply button (design has none).
    root.classList.add('is-live');

    function parseInput(el, fallback) {
      var n = parseFloat((el.value || '').replace(/[^0-9.\-]/g, ''));
      return isFinite(n) ? n : fallback;
    }
    function clamp(v) { return Math.min(max, Math.max(min, v)); }
    function pct(v) { return ((v - min) / (max - min)) * 100; }

    var lo = clamp(parseInput(inputMin, min));
    var hi = clamp(parseInput(inputMax, max));
    if (lo > hi) { var t = lo; lo = hi; hi = t; }

    function paint() {
      var lp = pct(lo), hp = pct(hi);
      knobLo.style.left = lp + '%';
      knobHi.style.left = hp + '%';
      fill.style.left = lp + '%';
      fill.style.right = (100 - hp) + '%';
      knobLo.setAttribute('aria-valuenow', String(Math.round(lo)));
      knobHi.setAttribute('aria-valuenow', String(Math.round(hi)));
    }
    function writeInputs() {
      inputMin.value = String(Math.round(lo));
      inputMax.value = String(Math.round(hi));
    }
    function commit() {
      writeInputs();
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }

    paint();

    // ----- Drag handling (pointer events) -----
    var dragging = null;
    function valueFromClientX(clientX) {
      var rect = track.getBoundingClientRect();
      if (rect.width <= 0) return min;
      var ratio = (clientX - rect.left) / rect.width;
      ratio = Math.min(1, Math.max(0, ratio));
      return min + ratio * (max - min);
    }
    function onMove(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var v = valueFromClientX(clientX);
      if (dragging === 'lo') { lo = clamp(Math.min(v, hi)); }
      else { hi = clamp(Math.max(v, lo)); }
      paint();
      writeInputs();
      if (e.cancelable) e.preventDefault();
    }
    function endDrag() {
      if (!dragging) return;
      dragging = null;
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', endDrag);
      commit();
    }
    function startDrag(which) {
      return function (e) {
        dragging = which;
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', endDrag);
        if (e.cancelable) e.preventDefault();
      };
    }
    knobLo.addEventListener('pointerdown', startDrag('lo'));
    knobHi.addEventListener('pointerdown', startDrag('hi'));

    // ----- Keyboard handling on knobs -----
    function keyStep(which) {
      return function (e) {
        var step = (max - min) / 100 || 1;
        var delta = 0;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') delta = -step;
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') delta = step;
        else if (e.key === 'Home') { if (which === 'lo') { lo = min; } else { hi = lo; } paint(); writeInputs(); commit(); e.preventDefault(); return; }
        else if (e.key === 'End') { if (which === 'hi') { hi = max; } else { lo = hi; } paint(); writeInputs(); commit(); e.preventDefault(); return; }
        else return;
        if (which === 'lo') lo = clamp(Math.min(lo + delta, hi));
        else hi = clamp(Math.max(hi + delta, lo));
        paint(); writeInputs();
        e.preventDefault();
      };
    }
    knobLo.addEventListener('keydown', keyStep('lo'));
    knobHi.addEventListener('keydown', keyStep('hi'));
    knobLo.addEventListener('keyup', function (e) { if (e.key && e.key.indexOf('Arrow') === 0) commit(); });
    knobHi.addEventListener('keyup', function (e) { if (e.key && e.key.indexOf('Arrow') === 0) commit(); });

    // ----- Input commit (Enter / blur) keeps knobs in sync -----
    function syncFromInputs() {
      lo = clamp(parseInput(inputMin, min));
      hi = clamp(parseInput(inputMax, max));
      if (lo > hi) { var t = lo; lo = hi; hi = t; }
      paint();
    }
    [inputMin, inputMax].forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); syncFromInputs(); commit(); }
      });
      el.addEventListener('blur', function () { syncFromInputs(); commit(); });
      el.addEventListener('input', function () {
        var l = parseInput(inputMin, lo), h = parseInput(inputMax, hi);
        if (isFinite(l)) lo = clamp(Math.min(l, max));
        if (isFinite(h)) hi = clamp(Math.max(h, min));
        paint();
      });
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ofx-price]');
    for (var i = 0; i < roots.length; i++) initSlider(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init after Shopify section re-renders (theme editor / Section Rendering API).
  document.addEventListener('shopify:section:load', initAll);
})();
